(function() {
    'use strict';
    angular
        .module('verificadocumentoApp')
        .factory('TituloElectronico', TituloElectronico);

    TituloElectronico.$inject = ['$resource'];

    function TituloElectronico ($resource) {
        var resourceUrl =  'api/titulo-electronicos/:folioControl';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
